import Box from '@/components/UI/box/Box';
import styles from './MidtermDiscount.module.scss';
import Typography from '@/components/UI/typography/Typography';
import Button from '@/components/UI/button/Button';
import Image from 'next/image';
import Icon from '@/components/UI/icon/Icon';
import Divider from '@/components/UI/divider/Divider';
import banner from '@/public/images/midtermSearch/banner.png';
import { FC } from 'react';
import { copyText } from '@/helpers/copyText';
interface Props {
  handleClose: () => void;
}
const MidtermDiscount: FC<Props> = ({
  handleClose
}) => {
  const code = 'shablong';
  return <Box className={styles['midterm-discount-popup-container']} data-sentry-element="Box" data-sentry-component="MidtermDiscount" data-sentry-source-file="MidtermDiscount.tsx">
      <Box className={styles['banner-image-container']} data-sentry-element="Box" data-sentry-source-file="MidtermDiscount.tsx">
        <Icon name="close" type="white" size={24} className={styles['close-button']} onClick={handleClose} data-sentry-element="Icon" data-sentry-source-file="MidtermDiscount.tsx" />

        <Image src={banner} alt="midterm discount" width={300} height={172} data-sentry-element="Image" data-sentry-source-file="MidtermDiscount.tsx" />
      </Box>
      <Box className={styles['content-container']} data-sentry-element="Box" data-sentry-source-file="MidtermDiscount.tsx">
        <Box className={styles['content-background-box']} data-sentry-element="Box" data-sentry-source-file="MidtermDiscount.tsx">
          <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="MidtermDiscount.tsx">
            کد تخفیف ۲۰ میلیون تومانی!
          </Typography>
          <Typography variant="bodyM" className={styles['discount-description']} data-sentry-element="Typography" data-sentry-source-file="MidtermDiscount.tsx">
            کاربر خوش شانس شب کد تخفیف ٪۱۰ رزرو ماهانه تا سقف ۲۰ میلیون و تا آخر
            هفته برای شما فعال شد.
          </Typography>
          <Divider className={styles['content-box-divider']} data-sentry-element="Divider" data-sentry-source-file="MidtermDiscount.tsx" />
          <Box className={styles['discount-code-container']} data-sentry-element="Box" data-sentry-source-file="MidtermDiscount.tsx">
            <Typography variant="bodyS" className={styles['discount-code']} data-sentry-element="Typography" data-sentry-source-file="MidtermDiscount.tsx">
              {code}
            </Typography>
            <Button endIcon="document-copy" format="primary" size="small" className={styles['copy-button']} onClick={() => {
            copyText(code);
          }} data-sentry-element="Button" data-sentry-source-file="MidtermDiscount.tsx">
              کپی کردن کد
            </Button>
          </Box>
          <Box className={styles['half-circle-right']} data-sentry-element="Box" data-sentry-source-file="MidtermDiscount.tsx" />
          <Box className={styles['half-circle-left']} data-sentry-element="Box" data-sentry-source-file="MidtermDiscount.tsx" />
        </Box>
      </Box>
    </Box>;
};
export default MidtermDiscount;